export default "__VITE_ASSET__CY57YlDW__"